import { useState, useEffect } from 'react';
import { useQuery } from '../../../../common/apollo-graphql';
import { GET_CLINIC_DROPDOWN_OPTIONS_QUERY } from '../../../clinics/gql/Query';

export default function useClinicDropdownOptions({ value, onOptionsLoaded = null }) {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);

  const { loading, data } = useQuery(GET_CLINIC_DROPDOWN_OPTIONS_QUERY, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      orderByColumn: 'name',
      orderBy: 'asc',
    },
  });

  useEffect(() => {
    if (Array.isArray(data?.rows)) {
      setOptions(data.rows);
      if (onOptionsLoaded) onOptionsLoaded(data.rows);
    }
  }, [data, onOptionsLoaded]);

  useEffect(() => {
    setSelected(data?.rows?.find((c) => String(c.id) === String(value)) || null);
  }, [data, value]);

  return { options, selected, loading };
}
